import React, { useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { TextInputform } from "../../components/Forms";

const ProductCreation = ({ formData, setFormData, schema, allProducts, editMode }) => {
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
useEffect(() => {
  const productName = (formData.product_name || "").trim();
  const multipliers = {
    "2000 வாலா": 2,
    "5000 வாலா": 4,
    "10000 வாலா": 8
  };

  // 1. Check if the current name is one of our "auto-fill" targets
  if (multipliers[productName]) {
    
    // 2. Find the base reference product
    const baseProduct = allProducts?.find(
      p => (p.product_name || "").trim() === "1000 வாலா"
    );

    if (baseProduct) {
      const factor = multipliers[productName];

      // 3. Calculate new values
      const newKnitting = (parseFloat(baseProduct.Knitting_wage || 0) * factor).toString();
      const newPacking = (parseFloat(baseProduct.packing_cooly || 0) * factor).toString();
      const newUnit = (parseFloat(baseProduct.unit_cooly || 0) * factor).toString();
      const newDeluxe = (parseFloat(baseProduct.deluxe_Knitting_wage || 0) * factor).toString();

      // 4. Optimization: Only update state if the values are actually different
      // This prevents infinite loops or overwriting manual edits unnecessarily
      if (
        formData.Knitting_wage !== newKnitting ||
        formData.packing_cooly !== newPacking
      ) {
        setFormData(prev => ({
          ...prev,
          Knitting_wage: newKnitting,
          packing_cooly: newPacking,
          unit_cooly: newUnit,
          deluxe_Knitting_wage: newDeluxe,
        }));
      }
    }
  }
}, [formData.product_name, allProducts, setFormData]); // Removed editMode from logic

  return (
    <div>
      <Container>
        <Row>
          {schema.map((field, index) => (
            <Col lg="12" md="12" xs="12" className="py-3" key={index}>
              <TextInputform
                textlabel={field.label}
                formLabel={field.label}
                PlaceHolder={field.label}
                name={field.name}
                value={formData[field.name] || ""}
                formtype={field.type}
                onChange={handleChange}
                classname={field.classname || ""}
              />
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default ProductCreation;